import * as React from "react";
import * as React44ms from "../../../Util/form-utils/react-44ms";

import {
  DataSourceAddressParseQueryProvider,
  DataSourceAddressParseQueryProviderProps,
} from "./data-source-address-parse-query";

export interface DataSourceAddressParseControllerConsumerInterface {
  request: (desiredAddress: DataSourceAddressParseQueryProviderProps) => void;
}

const defaultValue =
  {} as unknown as DataSourceAddressParseControllerConsumerInterface;

const DataSourceAddressParseControllerContext =
  React.createContext(defaultValue);
const DataSourceAddressParseControllerContext_44 =
  React44ms.React.createContext(
    defaultValue,
    DataSourceAddressParseControllerContext
  );

export const DataSourceAddressParseControllerProvider: React.FunctionComponent =
  (props) => {
    const [desiredAddress, setDesiredAddress] =
      React.useState<DataSourceAddressParseQueryProviderProps | null>();

    const request: DataSourceAddressParseControllerConsumerInterface["request"] =
      React.useCallback((desiredAddress) => {
        if ((desiredAddress.addressToParse || "").length > 0) {
          setDesiredAddress(desiredAddress);
        } else {
          setDesiredAddress(null);
        }
      }, []);

    const value: DataSourceAddressParseControllerConsumerInterface =
      React.useMemo(
        () => ({
          request,
        }),
        [request]
      );

    return (
      <DataSourceAddressParseControllerContext.Provider value={value}>
        <DataSourceAddressParseControllerContext_44.Provider value={value}>
          <DataSourceAddressParseQueryProvider
            addressToParse={desiredAddress?.addressToParse}
            countryCode={desiredAddress?.countryCode}
          >
            {props?.children || []}
          </DataSourceAddressParseQueryProvider>
        </DataSourceAddressParseControllerContext_44.Provider>
      </DataSourceAddressParseControllerContext.Provider>
    );
  };

export const useDataSourceAddressParseController = () => {
  const context = React.useContext(DataSourceAddressParseControllerContext);
  if (context === defaultValue) {
    throw new Error(
      "useDataSourceAddressParseController must be used within a DataSourceAddressParseControllerProvider"
    );
  }
  return context;
};

export const useDataSourceAddressParseController_44 = () => {
  const context = React44ms.React.useContext(
    DataSourceAddressParseControllerContext_44
  );
  if (context === defaultValue) {
    throw new Error(
      "useDataSourceAddressParseController must be used within a DataSourceAddressParseControllerProvider"
    );
  }
  return context;
};
